// import { TransactionService } from "./../Transaction Components/transaction.service";
import { Customer, FunctionResponse } from './../interfaces/master.interface';
// import { Schedule } from "./../interfaces/Schedule.interface";
import { Injectable } from '@angular/core';
import { TSubLedger, TrnProd } from './../interfaces/TrnMain';
import { TAcList } from './../interfaces/Account.interface';
import * as _ from 'lodash';
import { IRateGroup, IDivision } from '../interfaces/commonInterface.interface';
// import { SalesTerminal } from "../../pages/masters/components/sales-terminal/sales-terminal.interface"
import {
  HttpClient,
  HttpResponse,
  HttpHeaders,
  HttpRequest,
} from '@angular/common/http';
import { AuthService } from '../services/permission/authService.service';
import { observable, Subject } from 'rxjs';
import { GlobalState } from '../../global.state';
import { Observable } from 'rxjs';
import { Subscriber } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import {
  Item,
  VoucherTypeEnum,
  TrnMain,
  CostCenter,
  Warehouse,
  AcListTree,
} from '../interfaces/index';
import { SettingService } from '../services';
import { BehaviorSubject } from 'rxjs';
import { LoginDialog } from '../../pages/modaldialogs/index';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MessageDialog } from '../../pages/modaldialogs/messageDialog/messageDialog.component';
import { Company } from '../interfaces/CompanyInfo.interface';
import { data } from 'jquery';
@Injectable()
export class MasterRepo {
  //Message dialogbox
  // messageSubject: BehaviorSubject<string> = new BehaviorSubject<string>("");
  // message$: Observable<string> = this.messageSubject.asObservable();
  // childDialogRef: MdDialogRef<any>;
  //---end message dialogbox
  private _rateGroups: Array<IRateGroup> = [];
  InvMain: TrnMain = <TrnMain>{};
  DispatchName: any;
  private _account: TAcList[] = [];
  private _subLedger: TSubLedger[] = [];
  //private _reqOption: RequestOptions = <RequestOptions>{};
  public _itemList: Item[] = [];
  public quotationList: any[] = [];
  public _productList: Array<any> = [];
  public _DLitemList: Item[] = [];
  public PartialProductList: any[] = [];
  public ProductGroupTree: any[] = [];
  private _accountTree: any[] = [];
  private _accountPartyTree: any[] = [];
  public _ptypeList: any[] = [];
  public _Units: any[] = [];
  public Currencies: any[] = [];
  ProdList: TrnProd[] = [];
  TrnObj: any;
  TotalAmt: any;
  reportname: any;
  errorMessage: any;
  qjobList: any[] = [];
  qvno: any;
  qDelDate: any;
  DRJobNO: any;
  DLJobNO: any;
  callCustList: any[] = [];
  EnableRealTimeStockCheck: boolean;
  public msg: string = '';
  ItemList_Available: string = '';
  public _itemListDRObservable$!: Observable<Item[]>;
  public _itemServiceList: Item[] = [];
  public _itemServiceListObservable$!: Observable<Item[]>;
  getAccountObservable!: Observable<TAcList[]>;
  getAccountTreeObservable!: Observable<any[]>;
  getPartyTreeObservable!: Observable<any[]>;
  _jobDescList: any[] = [];
  public _jobDescObservable$!: Observable<any[]>;
  _QuotationInfoList: any[] = [];
  _QuotationObservable$!: Observable<any[]>;
  _OpenFlagList: any[] = [];
  _OpenflagObservable$!: Observable<any[]>;
  _VehicleJobInfoList: any[] = [];
  _VehicleJobObservable$!: Observable<any[]>;
  _CustomerInfoList: any[] = [];
  _CustomerObservable$!: Observable<any[]>;
  public _productObservable$!: Observable<any[]>;
  _DispatchInList: any[] = [];
  _DispatchInObservable$!: Observable<any[]>;
  _DispatchOutList: any[] = [];
  _DispatchOutObservable$!: Observable<any[]>;
  private _jobList: any[] = [];
  public _JobitemListObservable$!: Observable<Item[]>;
  private _mechanicList: any[] = [];
  public _mechanicListObservable$!: Observable<Item[]>;
  private _supervisorList: any[] = [];
  public _supervisorObservable$!: Observable<Item[]>;
  _SERVICESList: any[] = [];
  _SERVICESListObservable$!: Observable<any[]>;
  _vehicleSettingList: any[] = [];
  public _vehicleSettingObservable$!: Observable<Customer[]>;
  _AMCList: any[] = [];
  public _AMCObservable$!: Observable<any[]>;
  // companyProfile:any;
  private get _lastProductChangeDateLocal(): Date {
    return <Date>(
      this.authService.getSessionVariable('LastProductChangeDateLocal')
    );
  }
  public get itemList(): Item[] {
    console.log('ListItem', this._itemList);
    return this._itemList;
  }
  public get accountList(): TAcList[] {
    return this._account;
  }

  //Observable for divisionList
  public _divisions: Array<IDivision> = [];

  private _divisionListObservable!: Observable<Array<IDivision>>;
  public rateGroups: Subject<Array<IRateGroup>> = new Subject();
  private Subscriptions: any[] = [];
  public PartialAccountList: any[] = [];
  private _receipeitemList: any[] = [];
  public _receipeitemListObservable$!: Observable<any[]>;
  private _comboList: any[] = [];
  public _ComboListObservable$!: Observable<any[]>;
  _JobCardList: any[] = [];
  public _jobcardObservable$!: Observable<Customer[]>;
  _JobCardClosedList: any[] = [];
  public _jobcardClosedObservable$!: Observable<Customer[]>;
  _VehicleInfoList: any[] = [];
  _VehicleObservable$!: Observable<any[]>;
  _EngineInfoList: any[] = [];
  _EngineObservable$!: Observable<any[]>;

  _freeServiceList: any[] = [];
  public _freeServiceObservable$!: Observable<any[]>;
  _quotationList: any[] = [];
  public _quotationdObservable$!: Observable<Customer[]>;
  _modelMappingList: any[] = [];
  public _modelMappingObservable$!: Observable<any[]>;
  onViewClick: boolean = false;

  //constructor
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private state: GlobalState,
    // private dbWrapper: IndexedDbWrapper,
    public dialog: MatDialog,
    private setting: SettingService
  ) {
    console.log({ authoservice: authService });
    //setting requestOption with headers and authorizationkey
    //this.getRateGroups();
    //this.getRateGroupsFromApi();
    //this.EnableRealTimeStockCheck = authService.
    this.EnableRealTimeStockCheck = this.authService.getSetting();

    // this.refreshTransactionList();
    //this.getRateGroupList();
    // console.log({ database: this.dbWrapper.dbHelper });
    // this.DispatchName='DispatchIn';
  }

  public refreshTransactionList() {
    if (this._divisionListSubject.getValue().length == 0) {
      this.refreshDivsionList();
    }
    if (this.costCenterSubject.getValue().length == 0) {
      this.refreshCostCenters();
    }
    if (this.warehouseSubject.getValue().length == 0) {
      this.refreshWarehouses();
    }
    if (this.rateGroupSubject.getValue().length == 0) {
      this.refreshRateGroupList();
    }
    if (this.accountSubject.getValue().length == 0) {
      this.refreshAccountList('maseter initial');
    }
  }

  //OBSERVABLE ReDefined
  //Division list observable
  private allDivisionSubject: BehaviorSubject<IDivision[]> =
    new BehaviorSubject<IDivision[]>([]);
  public allDivisionList$: Observable<IDivision[]> =
    this.allDivisionSubject.asObservable();
  public _divisionListSubject: BehaviorSubject<IDivision[]> =
    new BehaviorSubject<IDivision[]>([]);
  public divisionList$: Observable<IDivision[]> =
    this._divisionListSubject.asObservable();
  public refreshDivsionList(refresh: boolean = false) {
    let divList: IDivision[] = [];
    console.log({ userdivisionlist: this.setting.appSetting.userDivisionList });
    this.httpGet('/getDivisionlist')
      .pipe(map((res: any) => res || []))
      .pipe(
        map((ret: any) => {
          divList.push(<IDivision>ret);
          this.allDivisionSubject.next(divList);
          return divList;
        })
      )
      .pipe(
        map((ret: any) => {
          if (this.setting.appSetting.UserwiseDivision == 1) {
            var divs: IDivision[] = [];
            var userdivs = <string[]>this.setting.appSetting.userDivisionList;
            ret.forEach((div: any) => {
              var divitem = userdivs.find((d) => d == div.INITIAL);
              if (divitem) {
                divs.push(div);
              }
            });
            return divs;
          } else {
            return ret;
          }
        })
      )
      .subscribe(
        (data: any) => {
          this._divisionListSubject.next(data);
        },
        (error: any) => {
          var err = error;
          alert(err);
        },
        () => {
          this._divisions = divList;
        }
      );
  }
  //-------end of divisionlist----------------

  //Cost Center
  public costCenterSubject: BehaviorSubject<CostCenter[]> = new BehaviorSubject<
    CostCenter[]
  >([]);
  public costCenterList$: Observable<CostCenter[]> =
    this.costCenterSubject.asObservable();

  public refreshCostCenters() {
    console.log({ getCostCenterList: 'entered' });
    let _costCenterList: CostCenter[] = [];
    this.httpGet('/getCostCenterList')
      .pipe(map((res: any) => res || []))
      .pipe(
        map((ret: any) => {
          _costCenterList.push(<CostCenter>ret);
          return _costCenterList;
        })
      )
      .subscribe(
        (data: any) => {
          this.costCenterSubject.next(data);
        },
        (error: any) => {
          this.resolveError(error, 'masterRepo-getCostCenters');
        }
      );
  }

  getBrand() {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    this.httpGet('/getBrandList').subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  getCustomer() {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    this.httpGet('/getCustomerList').subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  getBrandModelList(brand: any) {
    //
    return this.httpGet('/getModelList?brandname=' + brand).pipe(
      map((res: any) => res || [])
    );
  }

  getStockCheck(
    mcode: string,
    qtyselected: number,
    inputvchrtype: string = ''
  ) {
    let profile = this.authService.getUserProfile();
    let warehouse = profile.WAREHOUSE;
    let division = profile.DIVISION;
    console.log({ warehouse: warehouse, division: division });
    return this.httpGet(
      '/getCheckStock',
      `mcode=${mcode}&qtyselected=${qtyselected}&warehouse=${warehouse}&division=${division}&voucher=${inputvchrtype}`
    );
  }

  //---end costcenter
  // WarehouseList
  public warehouseSubject: BehaviorSubject<Warehouse[]> = new BehaviorSubject<
    Warehouse[]
  >([]);
  public warehouseList$: Observable<Warehouse[]> =
    this.warehouseSubject.asObservable();
  private allWarehouseSubject: BehaviorSubject<Warehouse[]> =
    new BehaviorSubject<Warehouse[]>([]);
  public allWarehouseList$: Observable<Warehouse[]> =
    this.allWarehouseSubject.asObservable();
  public refreshWarehouses() {
    let wlist: Warehouse[] = [];
    this.httpGet('/getWarehouseList')
      .pipe(map((response: any) => response || []))
      .pipe(
        map((ret: any) => {
          wlist.push(<Warehouse>ret);
          this.allWarehouseSubject.next(wlist);
          return wlist;
        })
      )
      .pipe(
        map((ret: any) => {
          if (this.setting.appSetting.UserwiseDivision == 1) {
            var wares: Warehouse[] = [];
            var userWares = <string[]>this.setting.appSetting.userWarehouseList;
            userWares.forEach((ware) => {
              var war = ret.find((w: any) => w.NAME == ware);
              if (war) {
                wares.push(war);
              }
            });
            return wares;
          } else {
            return ret;
          }
        })
      )
      .subscribe(
        (data: any) => {
          this.warehouseSubject.next(data);
        },
        (error: any) => {
          this.resolveError(error, 'masterService-getwarehouses');
        }
      );
  }
  //---end of WarehouseList
  //------end of redefined

  // RateGroupList
  public rateGroupSubject: BehaviorSubject<IRateGroup[]> = new BehaviorSubject<
    IRateGroup[]
  >([]);
  public rateGroupList$: Observable<IRateGroup[]> =
    this.rateGroupSubject.asObservable();
  public refreshRateGroupList() {
    let rlist: IRateGroup[] = [];
    this.httpGet('/getRateGroupList')
      .pipe(map((response: any) => response || []))
      .pipe(
        map((ret: any) => {
          rlist.push(<IRateGroup>ret);
          return rlist;
        })
      )

      .subscribe(
        (data: any) => {
          this.rateGroupSubject.next(data);
        },
        (error: any) => {
          this.resolveError(error, 'masterService-getrateGroup');
        }
      );
  }
  //---end of RateGroupList
  //accountlist
  accountSubject: BehaviorSubject<TAcList[]> = new BehaviorSubject<TAcList[]>(
    []
  );
  accountList$: Observable<TAcList[]> = this.accountSubject.asObservable();
  public refreshAccountList(calledFrom: string) {
    console.log({ refreshAccountlist: calledFrom });
    var ilist: TAcList[] = [];
    if (this._account.length > 0) return;
    this.httpGet('/getAccountList')
      .pipe(map((res: any) => res || []))
      .subscribe(
        (data: any) => {
          ilist.push(<TAcList>data);
          // console.log({refreshAccountList:data,count:ilist.length, itemdata:this._account})
          this.accountSubject.next(ilist);
        },
        (Error: any) => {
          console.log({
            calledFrom: calledFrom,
            RefreshAccountlistError: Error,
          });
          this.accountSubject.complete();
        },
        () => {
          this._account = ilist;
          this.accountSubject.next(ilist);
          this.accountSubject.complete();
          console.log({
            refreshAccountListFinish: ilist,
            count: ilist.length,
            itemdata: this._account.length,
          });
        }
      );
  }
  //end accountlist
  public get apiUrl(): string {
    let url = this.state.getGlobalSetting('apiUrl');
    let apiUrl = '';

    if (!!url && url.length > 0) {
      apiUrl = url[0];
    }
    console.log({ apiUrl: apiUrl });
    return apiUrl;
  }
  public getRequestOption(contentType: string) {
    // let headers: Headers = new Headers({
    //   'Content-type': 'application/json',
    //   Authorization: this.authService.getAuth().token,
    // });

    // return new RequestOptions({ headers: headers });
    if (contentType == '') contentType = 'application/json';
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization:
          this.authService.getAuth().token == null
            ? ''
            : this.authService.getAuth().token,
        'Content-Type': contentType,
      }),
    };
    console.log({ httpoption: httpOptions });
    return httpOptions;
  }

  prodListHttp$ = this.httpPost('/getProductList', {
    EDATE: this._lastProductChangeDateLocal,
  }).pipe(map((res: any) => res || []));

  public getVoucherNo(TrnMainObj: any) {
    let returnSubject: Subject<any> = new Subject();
    this.httpPost('/getVoucherNo', TrnMainObj).subscribe((data: any) => {
      let retData = data;
      if (retData.status == 'ok') {
        returnSubject.next(retData);
      } else {
        console.log(retData);
        returnSubject.next(retData);
      }
    });
    return returnSubject;
  }

  public getBulkMessage(messageObj: any) {
    let returnSubject: Subject<any> = new Subject();
    this.httpPost('/sendbulkmessage', messageObj).subscribe((data: any) => {
      let retData = data;
      if (retData.status == 'ok') {
        returnSubject.next(retData);
        returnSubject.unsubscribe();
      } else {
        console.log(retData);
        returnSubject.next(retData);
        returnSubject.unsubscribe();
      }
    });
    return returnSubject;
  }

  public sendmessageBrandwise(messageObj: any) {
    let returnSubject: Subject<any> = new Subject();
    return this.httpPost('/sendmessageBrandwise', messageObj);
    // .subscribe(data => {
    //     let retData = data;
    //     if (retData.status == "ok") {
    //         console.log(retData)
    //         this.msg = "message sent successfully"
    //         returnSubject.next(retData);
    //         console.log("thismsg",this.msg)

    //     }
    //     else {
    //         console.log(retData);
    //         returnSubject.next(retData);
    //         this.msg = "message wasn't sent "

    //     }

    // });
    // return returnSubject;
  }

  public getCustomerWiseMessage(messageObj: any) {
    console.log('inside customerWiseMessage');
    let returnSubject: Subject<any> = new Subject();
    this.httpPost('/sendSinglemessage', messageObj).subscribe((data: any) => {
      let retData = data;
      if (retData.status == 'ok') {
        returnSubject.next(retData);
      } else {
        console.log(retData);
        returnSubject.next(retData);
      }
    });
    return returnSubject;
  }

  public _itemListObservable$!: Observable<Item[]>;
  public getProductItemList() {
    // alert("reacheds")
    if (this._itemList.length > 0) {
      // alert("reached")
      console.log('1');
      console.log({
        getproductItemList: 'from Array',
        items: this._itemList,
      });
      //return this._itemList;
      return new Observable((observer) => observer.next(this._itemList));
    } else if (this._itemListObservable$) {
      console.log('2');
      console.log(this._itemListObservable$, '22');
      // console.log({ itemlistObservable: this._itemListObservable$ });
      return this._itemListObservable$;
    } else {
      console.log('3');

      // this._itemListObservable$ = new Observable<Item[]>{};
      //  console.log({ productItemlistReqOptions: this.getRequestOption });
      return this.httpPost('/getProductList', {
        EDATE: this._lastProductChangeDateLocal,
      })
        .pipe(map((res: any) => res || []))
        .pipe(
          map((data: any) => {
            this._itemList.push(<Item>data);
            return this._itemList;
          })
        );
      //return this._itemListObservable$;
    }
  }

  public getDLProductItemList(jcno: any) {
    // alert("reacheds")
    if (this._DLitemList.length > 0) {
      //   console.log({ getproductItemList: 'from Array', items: this._itemList })
      //return this._itemList;
      return new Observable((observer) => {
        observer.next(this._DLitemList);
      });
    } else if (this._itemListDRObservable$) {
      // console.log({ itemlistObservable: this._itemListObservable$ });
      return this._itemListDRObservable$;
    } else {
      //this._itemListDRObservable$ = null;
      let bodyData = { JCNO: jcno };
      return this.httpPost('/getDLProductList', bodyData)
        .pipe(map((res: any) => res || []))
        .pipe(
          map((data: any) => {
            this._DLitemList.push(<Item>data);
            return this._DLitemList;
          })
        );
      //return this._itemListDRObservable$;
    }
  }

  public getProductItemServiceList() {
    if (this._itemServiceList.length > 0) {
      //   console.log({ getproductItemList: 'from Array', items: this._itemList })
      //return this._itemList;
      return new Observable((observer) => {
        observer.next(this._itemServiceList);
      });
    } else if (this._itemServiceListObservable$) {
      // console.log({ itemlistObservable: this._itemListObservable$ });
      return this._itemServiceListObservable$;
    } else {
      //this._itemServiceListObservable$ = null;
      //  console.log({ productItemlistReqOptions: this.getRequestOption });
      return this.httpPost('/getProductServiceList', {
        EDATE: this._lastProductChangeDateLocal,
      })
        .pipe(map((res: any) => res || []))
        .pipe(
          map((data: any) => {
            this._itemServiceList.push(<Item>data);
            return this._itemServiceList;
          })
        );
      //return this._itemServiceListObservable$;
    }
  }
  // public getProductItemList() {
  //     try {
  //         var db = this.dbWrapper.dbHelper;
  //         if (this._itemList.length > 0) {
  //             console.log({ getproductItemList: 'from Array', items: this._itemList })
  //             return Observable.of(this._itemList);
  //         }
  //         else if(this._itemListObservable$){
  //             return this._itemListObservable$;
  //         }
  //         else if(db){
  //             this.dbWrapper.dbHelper.openCursor('PRODUCT', (evt) => {
  //                 let cursor = <IDBCursorWithValue>evt.target.result;
  //                 if (cursor) {
  //                     this._itemList.push(<Item>cursor.value);
  //                     cursor.continue();
  //                 }
  //                 else {
  //                     return Observable.of(this._itemList);
  //                 }
  //             }).catch((error:any) => {
  //                 console.log({ IndexedDbError: error });
  //                 this.refreshProductItemList();
  //                 return;
  //                 //return Observable.of([]);
  //             });
  //         }
  //         else{
  //             var lastProductChangeDateLocal = this.authService.getSessionVariable('LastProductChangeDateLocal');
  //             console.log({ lastProductChangeDateLocal: lastProductChangeDateLocal });
  //             if (lastProductChangeDateLocal) {
  //                 console.log({ getproductItemList: 'from http', items: this._itemList })
  //                 this.refreshProductItemList();

  //             }

  //         }
  //     }
  //     catch (ex) {
  //         console.log({ getProduclistError: ex });
  //     }
  // }
  public refreshProductItemList() {
    try {
      if (this._itemList.length > 0) return;
      var plist: Item[] = [];
      var LastDate = new Date('1900-01-01T00:00:00');
      // var db = this.dbWrapper.dbHelper;
      this.prodListHttp$.subscribe(
        (data: any) => {
          var pitem = <Item>data;
          if (LastDate < pitem.EDATE) {
            LastDate = pitem.EDATE;
          }
          console.log('Updating Database');
          // db.update('PRODUCT', pitem).catch((error: any) => {
          //   console.log({ ItemImportError: error });
          // });
        },
        (Error: any) => console.log(Error),
        () => {
          this.authService.removeSessionVariable('LastProductChangeDateLocal');
          //this._itemList = plist;
          //console.log({ refreshProductItem: plist, count: plist.length, itemdata: this._itemList.length })
        }
      );
    } catch (ex) {
      console.log({ refreshProductlistError: ex });
    }
  }

  // public getProductItemList() {
  //     return new Observable((observer: Subscriber<Array<Item>>) => {
  //         console.log({itemLength:this._itemList.length,items:this._itemList})
  //         if (this._itemList.length > 0) {
  //             console.log('ListReturn from array')
  //             observer.next(this._itemList);
  //             observer.complete();
  //         }
  //         else {
  //             this.http.get( '/getProductList', this.getRequestOption())
  //                 .flatMap(res => res || [])
  //                 .subscribe(data => {
  //                     console.log('ListReturn from http')
  //                     this._itemList.push(<Item>data);
  //                     observer.next(this._itemList)
  //                 },
  //                 Error => {
  //                     observer.complete();
  //                     observer.error(Error);
  //                 }
  //                 ,
  //                 () => observer.complete()
  //                 )
  //         }
  //     }
  //     );
  // }
  // public getRateGroupList(): Array<IRateGroup> {
  //     if (this._rateGroups.length > 0) {
  //         return this._rateGroups;
  //     }
  //     this.http.get( '/getRateGroupList', this.getRequestOption())
  //         .flatMap(Response => Response || [])
  //         .subscribe(data => {
  //             this._rateGroups.push(<IRateGroup>data)
  //         })
  // }
  public getRateGroups() {
    console.log('getRateGroupCalled');

    this.state.subscribe('rateGroupList', (data: any) => {
      this._rateGroups = data;
      this.rateGroups.next(data);
      console.log({ rategroup: data });
    });
  }

  private getRateGroupsFromApi() {
    console.log('getrategroupApiCalle');
    let url = this.state.getGlobalSetting('apiUrl');
    let apiUrl;

    if (!!url && url.length > 0) {
      apiUrl = url[0];
    }
    let retRateGroups: Array<IRateGroup> = [];
    this.httpGet(apiUrl + '/getRateGroupList')
      .pipe((Response: any) => Response || [])
      .subscribe(
        (data: any) => {
          retRateGroups.push(<IRateGroup>data);
          console.log('dataofRategroupreceived');
        },
        (error: any) => {
          console.log({ status: 'rateGroup not loaded', result: error });
        },
        () => {
          console.log({ rateComplet: retRateGroups });
          this.state.notifyDataChanged('rateGroupList', retRateGroups);
        }
      );
  }

  public getAllJobcardNo() {
    //  console.log("reacjek")
    return this.httpGet('/getAllJobcardNo').pipe(
      map((response: any) => response || [])
    );
  }
  public getAllJobEndNO() {
    //  console.log("reacjek")
    return this.httpGet('/getAllJobEndNo').pipe(
      map((response: any) => response || [])
    );
  }
  public getAllBrand() {
    //  console.log("reacjek")
    //   alert("reached";)
    return this.httpGet('/getBrandsOnly').pipe(
      map((response: any) => response || [])
    );
  }
  public getCurrencies() {
    return this.httpGet('/getCurrencyList')
      .pipe(map((response: any) => response || []))
      .subscribe((res: any) => {
        this.Currencies.push(<any>res);
      });
  }
  public getSalesman(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getSalesmanList').pipe(
      map((response: any) => response || [])
    );
  }

  public getCostCenter(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getCostCenterList').pipe(
      map((response: any) => response || [])
    );
    //.subscribe(res=>{
    //   this._divisions.push(<IDivision>res);
    //this.subjectDivision.next(this._divisions);
    //})
  }
  public getAllCostCenter(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getAllCostCenterList').pipe(
      map((response: any) => response || [])
    );
    //.subscribe(res=>{
    //   this._divisions.push(<IDivision>res);
    //this.subjectDivision.next(this._divisions);
    //})
  }
  private getCostCenterFromApi() {}
  public getCategory(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getCategoryList').pipe(
      map((response: any) => response || [])
    );
    //.subscribe(res=>{
    //   this._divisions.push(<IDivision>res);
    //this.subjectDivision.next(this._divisions);
    //})
  }
  public getAllCategory(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getAllCategoryList').pipe(
      map((response: any) => response || [])
    );
    //.subscribe(res=>{
    //   this._divisions.push(<IDivision>res);
    //this.subjectDivision.next(this._divisions);
    //})
  }
  private getCategoryFromApi() {}
  public getSalesTerminal(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getSalesTerminalList').pipe(
      map((response: any) => response || [])
    );
  }

  public getWarehouse(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getAllWarehouseList').pipe(
      map((response: any) => response || [])
    );
  }

  public getWarehouse2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/getAllWarehouseList_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  public getproducttable(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getProductGroupTree').pipe(
      map((response: any) => response || [])
    );
  }

  public getproducttable2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/getProductGroupTree_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  getWarehouseFromDiv(div: string) {
    let res = { status: 'error', result: '' };
    let returnItemSubject: Subject<any> = new Subject();
    // console.log("CIDIDI", div)
    this.httpPost('/getWarehouseByDIV', { DIV: div }).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        } else {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnItemSubject.next(res);
        returnItemSubject.unsubscribe();
      }
    );
    return returnItemSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  public getAllDivision(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getAllDivisionList').pipe(
      map((response: any) => response || [])
    );
  }

  public getAllDivision2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/getAllDivisionList_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  public getTerminalCategory(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getTerminalCategoryList').pipe(
      map((response: any) => response || [])
    );
  }

  public getPType(refresh: boolean = false) {
    let ptypeList = [];
    return this.httpGet('/getPTypeList').pipe(
      map((response: any) => response || [])
    );
  }
  public getAllUnitList(refresh: boolean = false) {
    return this.httpGet('/getUnitList').pipe(
      map((response: any) => response || [])
    );
  }

  public getCounterProduct(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getCounterProductList').pipe(
      map((response: any) => response || [])
    );
  }
  // public getAccountList(): Array<TAcList> {
  //     if (this._account.length > 0) {
  //         return this._account;
  //     }
  //     else {
  //         this.http.get( '/getAccountList', this.getRequestOption())
  //             .flatMap(response => response || []).subscribe(res => {
  //                 this._account.push(<TAcList>res);
  //             }, Error => { console.log(Error) }
  //             , () => { return this._account })
  //     }
  // }

  public getAccount(calledFrom: string) {
    console.log({ getAccount: calledFrom });
    if (this._account.length > 0) {
      console.log({ getAccount: 'from array', list: this._account });
      return new Observable((observer) => {
        observer.next(this._account);
      });
    } else if (this.getAccountObservable) {
      console.log({ getAccount: 'from Observable', list: this._account });
      return this.getAccountObservable;
    } else {
      var aList: TAcList[] = [];
      // console.log({ url:  '/getAccountList', requestOpeiont: this.getRequestOption() })
      return this.httpGet('/getAccountList')
        .pipe(
          map((res: any) => {
            // console.log({ return: res, auth: this.getRequestOption(), url: 'getAccountList' })
            if (res.status == 400) {
              return new Observable((observer) => {
                observer.next([]);
              });
            } else if (res.status == 200) {
              return res || [];
            }
          })
        )
        .pipe(
          map((data: any) => {
            aList.push(<TAcList>data);
            this._account = aList;
            return aList;
          })
        );
      //return this.getAccountObservable;
    }
  }

  public getAccoutFilteredObs(keyword: any, byacid: number = 0) {
    return new Observable((observer: Subscriber<TAcList[]>) => {
      this.getAccount('getAccountFilteredObs')
        .pipe(
          map((aclist: any) => {
            if (byacid == 0) {
              console.log({ getAccountFilteredObs: 'byacid' });
              return aclist.filter((ac: any) =>
                ac.ACCODE == null
                  ? ''
                  : ac.ACCODE.toUpperCase().indexOf(keyword.toUpperCase()) > -1
              );
            } else {
              console.log({ getAccountFilteredObs: 'byacname' });
              return aclist.filter((ac: any) =>
                ac.ACNAME == null
                  ? ''
                  : ac.ACNAME.toUpperCase().indexOf(keyword.toUpperCase()) > -1
              );
            }
          })
        )
        .subscribe(
          (data: any) => {
            console.log({ getAccountFilteredObs: 'data', data: data });
            observer.next(data);
          },
          (Error: any) => {
            console.log({ getAccountFilterObs: Error });
            observer.complete();
          },
          () => {
            observer.complete();
          }
        );
    });
  }
  // public getAccoutFilteredObs1(keyword: any, byacid: number = 0) {
  //     return new Observable((observer: Subscriber<Array<TAcList>>) => {
  //         if (this._account.length == 0) {
  //             this.http.get( '/getAccountList', this.getRequestOption())
  //                 .flatMap(response => response || []).subscribe(res => {
  //                     this._account.push(<TAcList>res);
  //                     if (keyword) {
  //                         let filteredList;
  //                         if (byacid == 0) {
  //                             filteredList = this._account.filter((fil: TAcList) => {
  //                                 if (fil.ACCODE.toLowerCase().indexOf(keyword.toLowerCase()) != -1) {
  //                                     return fil;
  //                                 }
  //                             });
  //                         }
  //                         else {
  //                             filteredList = this._account.filter((fil: TAcList) => {
  //                                 if (fil.ACNAME.toLowerCase().indexOf(keyword.toLowerCase()) != -1) {
  //                                     return fil;
  //                                 }
  //                             });
  //                         }
  //                         console.log({ filtered: filteredList, total: this._account })
  //                         observer.next(filteredList);
  //                     }
  //                     else {
  //                         console.log({ notfiltered: this._account })
  //                         observer.next(this._account);
  //                     }

  //                 });
  //         }
  //         else {
  //             if (keyword) {
  //                 let filteredList;
  //                 if (byacid == 0) {
  //                     filteredList = this._account.filter((fil: TAcList) => {
  //                         if (fil.ACCODE.toLowerCase().indexOf(keyword.toLowerCase()) != -1) {
  //                             return fil;
  //                         }
  //                     });
  //                 }
  //                 else {
  //                     filteredList = this._account.filter((fil: TAcList) => {
  //                         if (fil.ACNAME.toLowerCase().indexOf(keyword.toLowerCase()) != -1) {
  //                             return fil;
  //                         }
  //                     });
  //                 }
  //                 console.log({ memoryfiltered: filteredList, total: this._account })
  //                 observer.next(filteredList);
  //             }
  //             else {
  //                 console.log({ notfiltered: this._account })
  //                 observer.next(this._account);
  //             }
  //         }
  //     })
  // }
  /*public getAccoutFilteredAcidObs2(keyword: any) {
        return new Observable(observer => {
            if (this._account.length == 0) {
                this.http.get( '/getAccountList', this.getRequestOption())
                    .flatMap(response => response || []).subscribe(res => {
                        this._account.push(<TAcList>res);
                        if (keyword) {
                            observer.next(this._account.filter((fil: TAcList) => fil.ACID.includes(keyword)));
                        }
                        else {
                            observer.next(this._account);
                        }

                    });
            }
            else {
                if (keyword) {
                    observer.next(this._account.filter((fil: TAcList) => fil.ACID.includes(keyword)));
                }
                else {
                    observer.next(this._account);
                }
            }
        })
    }*/

  /*public getAccountFiltered5(keyword: any) {
        if (this._account.length == 0) {
            return this.http.get( '/getAccountList', this.getRequestOption())
                .flatMap(response => response || [])
                .filter((fil: TAcList) => {
                    return fil.ACNAME.includes(keyword);
                });


        } else {
            console.log({ accoullistLoaded: this._account });
            if (keyword) {
                var aclist = this._account.filter(ac => ac.ACNAME.includes(keyword))
                console.log({ aclistAfterKeywordIn: aclist })
                return Observable.of(aclist);
            }
            else {

                Observable.of(this._account);
            }
        }

    }*/

  public getMembershipList(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getMembershipList').pipe(
      map((response: any) => response || [])
    );
  }

  public getOccupationList(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.http
      .get('/getOccupationList')
      .pipe(map((response: any) => response || []));
  }

  public getDesignationList(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getDesignationList').pipe(
      map((response: any) => response || [])
    );
  }

  public getMemberSchemeList(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getMemberSchemeList').pipe(
      map((response: any) => response || [])
    );
  }

  public getSalesmanList(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getSalesmanList').pipe(
      map((response: any) => response || [])
    );
  }

  public getSchemeGroupList(refresh: boolean = false) {
    // console.log({ request: this._reqOption });
    //
    return this.httpGet('/getSchemeGroupList').pipe(
      map((response: any) => response || [])
    );
  }

  public getSchemeList(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getSchemeList').pipe(
      map((response: any) => response || [])
    );
  }

  public getJournalList(refresh: boolean = false) {
    // console.log({ request: this._reqOption });

    return this.httpGet('/getJournalList').pipe(
      map((response: any) => response || [])
    );
  }

  public getProductGroupTree(refresh: boolean = false) {
    return this.httpGet('/getProductGroupTree').pipe(
      map((response: any) => response || [])
    );
  }
  public getACListTree(refresh: boolean = false) {
    return this.httpGet('/getACListTree').pipe(
      map((response: any) => response || [])
    );
  }
  public getUnits() {
    return this.httpGet('/getUnits').pipe(
      map((response: any) => response || [])
    );
  }
  public getMCatList() {
    return this.httpGet('/getMCatList').pipe(
      map((response: any) => response || [])
    );
  }
  public getMCat1List() {
    return this.httpGet('/getMCat1List').pipe(
      map((response: any) => response || [])
    );
  }
  public getRGroupList() {
    return this.httpGet('/getRGroupList').pipe(
      map((response: any) => response || [])
    );
  }
  public getWarehouseList() {
    return this.httpGet('/getWarehouseList').pipe(
      map((response: any) => response || [])
    );
  }
  // public getCostCenterList(refresh: boolean = false) {
  //     console.log({ request: this._reqOption });

  //     return this.http.get( '/getAllCostCenterList', this.getRequestOption())
  //         .flatMap(response => response || [])
  // }
  public getPTypeList() {
    return this.httpGet('/getPType').pipe(
      map((response: any) => response || [])
    );
  }
  public getKotCategoryList() {
    return this.httpGet('/getKotCategoryList').pipe(
      map((response: any) => response || [])
    );
  }
  public getBCodeDetails() {
    return this.http
      .get('/getBCodeDetails')
      .pipe(map((response: any) => response || []));
  }
  public getBrandList() {
    return this.httpGet('/getBrandList');
  }
  public getModelList() {
    return this.httpGet('/getModelList').pipe(
      map((response: any) => response || [])
    );
  }
  // public getSupplierList() { return this.http.get( '/getSupplierList', this.getRequestOption()).flatMap(response => response || []); }
  public getSupplierList() {
    return this.getAccount('masterrepo-supplierlist').pipe(
      map((data: any) => {
        let lst = data.filter(
          (fil: any) => fil.ACID.substr(0, 2) == 'PA' && fil.PType == 'V'
        );
        return lst;
      })
    );
  }

  public getCustomers() {
    return this.getAccount('masterrepo-customerlist').pipe(
      map((data: any) => {
        alert('reacchedCustomer');
        let lst = data.filter(
          (fil: any) => fil.ACID.substr(0, 2) == 'PA' && fil.PType == 'C'
        );
        return lst;
      })
    );
  }

  public getCashList() {
    return this.getAccount('masterrepo-cashlist').pipe(
      map((data: any) => {
        let lst = data.filter(
          (fil: any) => fil.ACID.substr(0, 2) == 'AT' && fil.MAPID == 'C'
        );
        return lst;
      })
    );
  }

  public getBankList() {
    return this.getAccount('masterrepo-banklist').pipe(
      map((data: any) => {
        let lst = data.filter(
          (fil: any) => fil.ACID.substr(0, 2) == 'AT' && fil.MAPID == 'B'
        );
        return lst;
      })
    );
  }

  public getAcList() {
    return this.httpGet('/getAcList').pipe(
      map((response: any) => response || [])
    );
  }
  // public getCustomers() { return this.http.get( '/getCustomers', this.getRequestOption()).flatMap(response => response || []); }
  // public getCashList() { return this.http.get( '/getCashList', this.getRequestOption()).flatMap(response => response || []); }
  // public getBankList() { return this.http.get( '/getBankList', this.getRequestOption()).flatMap(response => response || []); }
  public getPurchaseAcList() {
    return this.httpGet('/getPurchaseAcList').pipe(
      map((response: any) => response || [])
    );
  }
  public getSalesAcList() {
    return this.httpGet('/getSalesAcList').pipe(
      map((response: any) => response || [])
    );
  }
  public getCostCenterList() {
    return this.httpGet('/getCostCenterList').pipe(
      map((response: any) => response || [])
    );
  }
  public getSubLedgerList() {
    return new Observable((observer: Subscriber<TSubLedger[]>) => {
      if (this._subLedger.length == 0) {
        this.httpGet('/getSubLedgerList')
          .pipe(map((response: any) => response || []))
          .subscribe(
            (res: any) => {
              this._subLedger.push(<TSubLedger>res);
            },
            (error: any) => {
              observer.next([]);
            },
            () => {
              observer.next(this._subLedger);
            }
          );
      } else {
        observer.next(this._subLedger);
      }
    });
  }
  public getProductList() {
    return this.httpGet('/getProductList').pipe(
      map((response: any) => response || [])
    );
  }
  public getCashAndBankList() {
    return this.httpGet('/getCashAndBankList').pipe(
      map((response: any) => response || [])
    );
  }
  public getTrnMainList(prefix: string) {
    return this.httpGet('/getTrnMainList/' + prefix).pipe(
      map((response: any) => response || [])
    );
  }
  public getCurrentDate() {
    let date: Subject<any> = new Subject();
    this.httpGet('/getCurrentDate').subscribe((response: any) => {
      date.next(response);
      date.unsubscribe();
    });
    return date;
  }

  public getBarcodeWiseProductForTran(barcode: string) {
    return this.httpGet('/getBarcodeWiseProductForTran/' + barcode).pipe(
      map((response: any) => response || [])
    );
  }
  public getProductForTran(mcode: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    this.httpPost('/getProductForTran', {
      mcode: mcode,
    }).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  public getacListTree() {
    if (this._accountTree.length > 0) {
      return new Observable((observer) => observer.next(this._accountTree));
    }

    if (this.getAccountTreeObservable) {
      return this.getAccountTreeObservable;
    }

    //this.getAccountTreeObservable = null;
    var atList: AcListTree[] = [];
    return this.httpGet('/getAccountTree')
      .pipe((res: any) => {
        if (res.status == 400) {
          return new Observable((observer) => observer.next([]));
        } else if (res.status == 200) {
          return res || [];
        }
      })
      .pipe(
        map((data: any) => {
          //this.getAccountTreeObservable = null;
          atList.push(<AcListTree>data);
          this._accountTree = atList;
          return atList;
        })
      );
    //return this.getAccountTreeObservable;
  }

  public getpartyListTree() {
    if (this._accountPartyTree.length > 0) {
      return new Observable((observer) =>
        observer.next(this._accountPartyTree)
      );
    } else if (this.getPartyTreeObservable) {
      return this.getPartyTreeObservable;
    } else {
      var apList: any[] = [];
      return this.httpGet('/getPartyListTree')
        .pipe((res: any) => {
          if (res.status == 400) {
            return new Observable((observer) => observer.next([]));
          } else if (res.status == 200) {
            return res || [];
          }
        })
        .pipe(
          map((data: any) => {
            //this.getPartyTreeObservable = null;
            apList.push(<any>data);
            this._accountPartyTree = apList;
            return apList;
          })
        );
      //return this.getPartyTreeObservable;
    }
  }
  getAllAccount(ACID: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    let bodyData = { mode: 'query', data: { ACID: ACID } };
    this.httpPost('/getAccount', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  public saveTransaction(mode: string, trnmain: TrnMain, trnProd: TrnProd[]) {
    let trnprodlist: TrnProd[] = [];
    trnprodlist = trnProd;
    trnmain.ProdList = [];
    var messageSubject: BehaviorSubject<string> = new BehaviorSubject<string>(
      'Saving data Please wait a moment...'
    );
    var message$: Observable<string> = messageSubject.asObservable();
    // let childDialogRef = this.dialog.open(MessageDialog, {
    //   hasBackdrop: true,
    //   data: { header: 'Information', message: message$ },
    // });
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = {};
    // if (extra == null) {
    bodyData = { mode: mode, data: trnmain, dataprod: trnprodlist };
    console.log('as', trnmain, trnprodlist);
    // }
    // else {
    //     bodyData = { mode: mode, data: trnmain, extra: extra };
    // }
    console.log('savesalesinvoice', bodyData);
    this.httpPost('/saveTransaction', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          messageSubject.next('Data Saved Successfully');
          returnSubject.next(retData);
          setTimeout(() => {
            // childDialogRef.close();
          }, 1000);
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          messageSubject.next(res.result);
          setTimeout(() => {
            // childDialogRef.close();
            returnSubject.next(res);
          }, 3000);
        }
      },
      (error: any) => {
        messageSubject.next(error);
        this.resolveError(error, 'savetransaction');
        setTimeout(() => {
          // childDialogRef.close();
          returnSubject.next({ status: 'error', result: error });
        }, 3000);
      }
    );
    return returnSubject;
  }

  public saveUnit(mode: string, trnmain: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: trnmain };
    this.httpPost('/saveUnit', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
        }
      },
      (error: any) => {
        var er = error;
        console.log(er);
        // res.status = "error2", res.result = error;
        // console.log(res);
        returnSubject.next(er);
      }
    );
    return returnSubject;
  }
  public saveSalesTerminal(mode: string, salesTerminal: any, cpList: any[]) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = {
      mode: mode,
      data: salesTerminal,
      CounterProductList: cpList,
    };
    this.httpPost('/saveSalesTerminal', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public saveWarehouse(mode: string, warehouse: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: warehouse };
    this.httpPost('/saveWarehouse', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public saveSalesman(mode: string, salesman: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: salesman };
    this.httpPost('/saveSalesman', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public savePType(mode: string, salesman: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: salesman };
    this.httpPost('/savePType', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public saveProduct(
    mode: string,
    prodObj: any,
    RGLIST: any[],
    AlternateUnits: any[],
    PBarCodeCollection: any[],
    BrandModelList: any[]
  ) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = {
      mode: mode,
      data: {
        product: prodObj,
        rglist: RGLIST,
        alternateunits: AlternateUnits,
        bcodeList: PBarCodeCollection,
        bmList: BrandModelList,
      },
    };
    console.log('product json');
    var data = JSON.stringify(bodyData, undefined, 2);
    console.log(data);
    this.httpPost('/saveProductMaster', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public saveMembership(mode: string, membership: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: membership };
    this.httpPost('/saveMembership', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public saveDivision(mode: string, division: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // console.log("about to save")
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: division };
    this.httpPost('/saveDivision', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public saveCostCenter(mode: string, costCenter: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: costCenter };
    this.httpPost('/saveCostCenter', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public loadCompany() {
    return new Observable((observer: Subscriber<Company>) => {
      let res = { status: 'error', result: '' };
      this.httpGet('/loadCompanyInfo')
        .pipe(map((ret: any) => ret))
        .subscribe(
          (data: any) => {
            console.log({ loadcompanyRet: data });
            observer.next(data.result);
          },
          (error: any) => {
            let ret = this.resolveError(error, 'loadcompany');
            if (ret == 'Login resolved') {
              this.loadCompany();
              return;
            }
            observer.next(<Company>{});
            observer.complete();
          }
        );
    });
  }
  public saveCompany(mode: string, costCenter: any) {
    var messageSubject: BehaviorSubject<string> = new BehaviorSubject<string>(
      'Saving data Please wait a moment...'
    );
    var message$: Observable<string> = messageSubject.asObservable();
    let childDialogRef = this.dialog.open(MessageDialog, {
      hasBackdrop: true,
      data: { header: 'Information', message: message$ },
    });
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: costCenter };
    this.httpPost('/saveCompanyInfo', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          messageSubject.next('Data saved successfully');
          setTimeout(() => {
            childDialogRef.close();
          }, 1000);

          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          messageSubject.next(res.result);
          setTimeout(() => {
            childDialogRef.close();
          }, 1000);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        let ret = this.resolveError(error, 'savecompany');
        messageSubject.next(ret);
        setTimeout(() => {
          childDialogRef.close();
        }, 3000);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public saveCategory(mode: string, category: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: category };
    this.httpPost('/saveCategory', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public saveAccount(mode: string, Account: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: Account };
    this.httpPost('/saveAccount', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  //to load the vouher in trnmain. this is common function to load voucher
  public LoadTransaction(vchrno: string, division: string, phiscalID: string) {
    let bodyData = { VCHRNO: vchrno, DIVISION: division, PHISCALID: phiscalID };
    console.log({ bodydata: bodyData });
    return this.httpPost('/getViewVoucher', bodyData).pipe(
      map((data: any) => data)
    );
  }

  public getPrefixVname(vtype: VoucherTypeEnum) {
    // if (vtype == 14) { return 'TI'; }
    switch (vtype) {
      case 12:
        return 'JV';
      case 17:
        return 'PV';
      case 18:
        return 'RV';
      case 3:
        return 'PI';
      case 1:
        return 'SI';
      case 14:
        return 'TI';
      case 5:
        return 'IS';
      case 15:
        return 'CN';
      case 16:
        return 'DN';
      case 7:
        return 'TR';
      case 8:
        return 'TO';
      case 13:
        return 'DL';
      case 2:
        return 'SR';
      case 21:
        return 'DR';
      case 9:
        return 'DM';
      default:
        return '00';
    }
  }

  public checkUserValid() {
    return new Observable((observer: Subscriber<boolean>) => {
      this.httpGet('/checkLogin').subscribe(
        (data: any) => {
          this.state.setGlobalSetting('LoggedIn', ['true']);
          observer.next(true);
          observer.complete();
        },
        (Error: any) => {
          console.log({ checkUserValid: false });
          observer.next(false);
          observer.complete();
        },
        () => {
          observer.complete();
        }
      );
    });
  }

  public IsLoginDialogOpened: boolean = false;
  public resolveError(error: any, callFrom: string) {
    console.log({ callfrom: callFrom, Error: error });
    try {
      let dialogResult;
      if (error.statusText == 'Unauthorized') {
        if (this.IsLoginDialogOpened == true) {
          return;
        }
        this.IsLoginDialogOpened = true;
        let dialogRef = this.dialog.open(LoginDialog, { disableClose: true });
        dialogRef.afterClosed().subscribe((result) => {
          this.IsLoginDialogOpened = false;
        });
        return null;
      }
      let err = error;
      console.log({ errorconvert: err });
      if (
        err &&
        err == 'The ConnectionString property has not been initialized.'
      ) {
        if (this.IsLoginDialogOpened == true) {
          return;
        }
        this.IsLoginDialogOpened = true;
        let dialogRef = this.dialog.open(LoginDialog, { disableClose: true });
        dialogRef.afterClosed().subscribe((result: any) => {
          this.IsLoginDialogOpened = false;
        });
        return null;
      }
      console.log(error);
      return err;
    } catch (ex) {
      console.log({ callfrom: callFrom, catchError: ex });
    }
  }

  public saveClientTerminal(mode: string, value: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: value };
    this.httpPost('/saveClientTerminal', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  getSingleObject(postData: any, postUrl: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = { mode: 'query', data: postData };
    this.httpPost(postUrl, bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  public getList(data: any, url: any) {
    console.log({ getlist: data });
    return this.httpPost(url, data).pipe(map((data: any) => data));
  }
  public getSalesModeList(postobj: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    let bodyData = postobj;
    this.httpPost('/getSalesModeList', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  public getReceipeItemList(refreshFromDatabase: boolean = false) {
    if (this._receipeitemList.length > 0 && refreshFromDatabase == false) {
      return new Observable((observer) => observer.next(this._receipeitemList));
    } else if (
      this._receipeitemListObservable$ &&
      refreshFromDatabase == false
    ) {
      return this._receipeitemListObservable$;
    } else {
      console.log('from databse');
      //this._receipeitemListObservable$ = null;
      this._receipeitemList = [];
      return this.httpPost('/getReceipeItemList', {
        EDATE: this._lastProductChangeDateLocal,
      })
        .pipe((res: any) => res || [])
        .pipe(
          map((data: any) => {
            this._receipeitemList.push(<any>data);
            return this._receipeitemList;
          })
        );
      //return this._receipeitemListObservable$;
    }
  }

  public saveObject(mode: string, value: any, url: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: value };
    this.httpPost(url, bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  getParentWiseProduct(MCODE: string) {
    alert('MCODE' + MCODE);
    return this.httpGet('/getParentWiseProduct/' + MCODE).pipe(
      map((response: any) => response || [])
    );
  }
  public getTreeForSchemeDiscount_MGroup() {
    return this.httpGet('/getTreeForSchemeDiscount_MGroup').pipe(
      map((response: any) => response || [])
    );
  }
  public getTreeForSchemeDiscount_Parent() {
    return this.httpGet('/getTreeForSchemeDiscount_Parent').pipe(
      map((response: any) => response || [])
    );
  }

  // public getCustomerDetailByMobileNo(number) {
  //     let res = { status: "error", result: "" }
  //     let returnSubject: Subject<any> = new Subject();
  //     let opt = this.getRequestOption();
  //     let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
  //     let op: RequestOptions = new RequestOptions()
  //     let bodyData = {number };
  //     this.http.post( "/getCustomerDetailByMobileNo", number, this.getRequestOption())
  //         .subscribe(data => {
  //             let retData = data;
  //             console.log(retData);
  //             if (retData.status == "ok") {
  //                 res.status = "ok";
  //                 res.result = retData.result
  //                 console.log(res);
  //                 returnSubject.next(res);
  //                 returnSubject.unsubscribe();
  //             }
  //             else {
  //                 res.status = "error1"; res.result = retData.result;
  //                 console.log(res);
  //                 returnSubject.next(res);
  //                 returnSubject.unsubscribe();
  //             }
  //         },
  //             error => {
  //                 res.status = "error2", res.result = error;
  //                 console.log(res);
  //                 returnSubject.next(res);
  //                 returnSubject.unsubscribe();
  //             }
  //         );
  //     return returnSubject;

  // }

  public getCustomerDetailByMobileNo(postobj: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = { mobileno: postobj };
    this.httpPost('/getCustomerDetailByMobileNo', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  public saveschedule(mode: string, Account: any) {
    console.log('AccountTT', mode);
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: Account };
    this.httpPost('/saveschedule', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  public getAllSchedule() {
    return this.httpGet('/getSchedule').pipe(
      map((response: any) => response || [])
    );
  }
  public saveScheme(mode: string, Account: any[]) {
    console.log('SCHEM@', Account);
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: Account };
    console.log({ SchemeJson: bodyData });
    this.httpPost('/schemeSave', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public saveComboList(comboList: any[]) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { data: comboList };
    this.httpPost('/saveComboList', comboList).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  getSelectedComboList(Initial: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    let bodyData = { mode: 'query', data: { DisID: Initial } };
    alert('getSelectedComboList');
    this.httpPost('/GETSelectedComboList', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  getAllSchemeList(Initial: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    let bodyData = { mode: 'query', data: { DisID: Initial } };
    this.httpPost('/GetAllSchemeList', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  public getAllScheme() {
    return this.httpGet('/GetAllScheme').pipe(
      map((response: any) => response || [])
    );
  }

  getParentWiseProductforScheme(MCODE: string) {
    return this.httpGet('/getParentWiseProductforScheme/' + MCODE).pipe(
      map((response: any) => response || [])
    );
  }

  public getComboList() {
    if (this._comboList.length > 0) {
      return new Observable((observer) => observer.next(this._comboList));
    } else if (this._ComboListObservable$) {
      return this._ComboListObservable$;
    } else {
      //this._ComboListObservable$ = null;
      return this.httpPost('/GETcombolist', {
        EDATE: this._lastProductChangeDateLocal,
      })
        .pipe((res: any) => res || [])
        .pipe(
          map((data: any) => {
            this._comboList.push(<any>data);
            return this._comboList;
          })
        );
      //return this._ComboListObservable$;
    }
  }

  getComboIdWise(CID: string) {
    let res = { status: 'error', result: '' };
    let returnItemSubject: Subject<any> = new Subject();
    console.log('CIDIDI', CID);
    this.httpPost('/getItemfromComboId', { CID: CID }).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        } else {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnItemSubject.next(res);
        returnItemSubject.unsubscribe();
      }
    );
    return returnItemSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  getWarehouseWiseCounterProduct(value: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();

    this.httpPost('/getWarehouseWiseCounterProduct', value).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  checkConsumptionDate(a: string) {
    let res = { status: 'error', result: '' };
    let returnItemSubject: Subject<any> = new Subject();
    console.log('CIDIDI', a);
    this.httpPost('/checkConsumptionEntryDate', {
      CID: a,
    }).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        } else {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnItemSubject.next(res);
        returnItemSubject.unsubscribe();
      }
    );
    return returnItemSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  // List
  getConsumptionList(a: string) {
    let res = { status: 'error', result: '' };
    let returnItemSubject: Subject<any> = new Subject();
    console.log('CIDIDI', a);
    this.httpPost('/getConsumptionEntryList', {
      CID: a,
    }).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        } else {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnItemSubject.next(res);
        returnItemSubject.unsubscribe();
      }
    );
    return returnItemSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  public SaveConsumptionEntry(mode: string, List: any[], TRN: any) {
    console.log('SCHEM@', List);
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to save');
    // let opt = this.getRequestOption();
    //console.log(opt.headers.toJSON());
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { mode: mode, data: List, data2: TRN };
    console.log({ SchemeJson: bodyData });
    this.httpPost('/saveConsumption', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        console.log(retData);
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  //Table
  public getAllConsumption() {
    return this.httpGet('/getAllConsumption').pipe(
      map((response: any) => response || [])
    );
  }
  // private _AllConsumptionList: any[] = [];
  // public _AlllConsumptionListObservable$: Observable<any[]>;
  // public getAllConsumption() {
  //     alert("reached")
  //     try {
  //         if (this._AllConsumptionList.length > 0) {
  //             return Observable.of(this._AllConsumptionList);
  //         }
  //         else if (this._AlllConsumptionListObservable$) {

  //             return this._AlllConsumptionListObservable$;
  //         }
  //         else {
  //             this._AlllConsumptionListObservable$ = null;
  //             alert("reached2")
  //             this._AlllConsumptionListObservable$ = this.http.post( '/getAllConsumption', this.getRequestOption())
  //                 .flatMap(res => res || [])
  //                 .map(data => {
  //                     this._AllConsumptionList.push(<any>data)
  //                     return this._AllConsumptionList;
  //                 })
  //                 .share();
  //             return this._AlllConsumptionListObservable$;
  //         }

  //     }
  //     catch (ex) {
  //         console.log({ getReceipelistError: ex });
  //     }
  // }

  getConsumptionFromID(CID: string) {
    let res = { status: 'error', result: '' };
    let returnItemSubject: Subject<any> = new Subject();
    console.log('CIDIDI', CID);
    this.httpPost('/getConsumptionFromID', {
      CID: CID,
    }).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        } else {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnItemSubject.next(res);
        returnItemSubject.unsubscribe();
      }
    );
    return returnItemSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  getAllMcodeNAME() {
    return this.httpGet('/getAllMcodeNAME').pipe(
      map((response: any) => response || [])
    );
  }

  getAllSettlement() {
    return this.http
      .get('/getAllSettlement')
      .pipe(map((response: any) => response || []));
  }

  getSettlementMode() {
    return this.httpGet('/getSettlementMode').pipe(
      map((response: any) => response || [])
    );
  }
  getStockSettlementFromID(CID: string) {
    let res = { status: 'error', result: '' };
    let returnItemSubject: Subject<any> = new Subject();
    console.log('CIDIDI', CID);
    this.httpPost('/getStockSettlementFromID', {
      CID: CID,
    }).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        } else {
          returnItemSubject.next(data);
          returnItemSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnItemSubject.next(res);
        returnItemSubject.unsubscribe();
      }
    );
    return returnItemSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  /*Dropdown TextSearch(EG: Norsetting)*/

  public getJobList() {
    if (this._jobDescList.length > 0) {
      //   console.log({ getproductItemList: 'from Array', items: this._itemList })
      //return this._itemList;
      return new Observable((observer) => observer.next(this._jobDescList));
    } else if (this._jobDescObservable$) {
      // console.log({ itemlistObservable: this._itemListObservable$ });
      return this._jobDescObservable$;
    } else {
      //this._jobDescObservable$ = null;
      console.log({ productItemlistReqOptions: this.getRequestOption });
      return this.httpGet('/getallcompanyitem')
        .pipe((res: any) => res || [])
        .pipe(
          map((data: any) => {
            // console.log("data&&&&",data)
            this._jobDescList.push(<any>data);
            return this._jobDescList;
          })
        );
      //return this._jobDescObservable$;
    }
  }

  savejobCard(
    saveitemObj: any,
    saveList: any,
    mode: any,
    jobtype: any,
    syncJC: any,
    syncJCProd: any,
    jobCardUsedServiceList: any,
    CatList: any,
    ServiceList: any
  ) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = {
      data: saveitemObj,
      datalist: saveList,
      mode: mode,
      jobtype,
      syncJC,
      syncJCProd,
      jobCardUsedServiceList: jobCardUsedServiceList,
      CatList: CatList,
      ServiceList: ServiceList,
    };
    console.log('savejobcard data', bodyData);
    this.httpPost('/savejobCard', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  getSelecteditemcode(Itemcode: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    alert(Itemcode);
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { ic: Itemcode } };
    this.httpPost('/getSelecteditemcode', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  getallcompanyitem() {
    return this.httpGet('/getallcompanyitem').pipe(
      map((response: any) => response || [])
    );
  }

  public getallJobcard() {
    if (this._JobCardList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._JobCardList));
    } else if (this._jobcardObservable$) {
      console.log('Obser');
      return this._jobcardObservable$;
    } else {
      console.log('api');
      //this._jobcardObservable$ = null;
      this._JobCardList = [];
      return this.httpGet('/GetAllJobcard')
        .pipe((res: any) => res || [])
        .pipe(
          map((data: any) => {
            this._JobCardList.push(<any>data);
            return this._JobCardList;
          })
        );
      //return this._jobcardObservable$;
    }
  }

  public getallJobcard2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/GetAllJobcard_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  public getallClosedJobcard() {
    if (this._JobCardClosedList.length > 0) {
      // console.log("array");
      return new Observable((observer) =>
        observer.next(this._JobCardClosedList)
      );
    } else if (this._jobcardClosedObservable$) {
      // console.log("Obser");
      return this._jobcardClosedObservable$;
    } else {
      // console.log("api");
      //this._jobcardClosedObservable$ = null;
      this._JobCardClosedList = [];
      return this.httpGet('/GetAllClosedJobcard')
        .pipe((res: any) => res || [])
        .pipe(
          map((data: any) => {
            this._JobCardClosedList.push(<any>data);
            return this._JobCardClosedList;
          })
        );
      //return this._jobcardClosedObservable$;
    }
  }

  public getallClosedJobcard2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/GetAllClosedJobcard_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }
  // return this.httpGet(
  //   `/getDefaultServiceBookList?model=`
  // )
  getdefaultServiceBook(brand: any, model: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    const Brand = brand;
    const Model = model;
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    // let bodyData = { data: { cid: id } };
    this.httpGet(
      `/getDefaultServiceBookList?brand=${Brand}&model=${Model}`
    ).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  public getJobCardNo() {
    return this.httpGet('/GetAllClosedJobcard').pipe(
      map((res: any) => res || [])
    );
  }

  getSelectedMechanic(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = { data: { cid: id } };
    this.httpPost('/getSelectedMechahic', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  discontinueMechanic(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = { data: { cid: id } };
    this.httpGet('/V2/discontinueMechanic', `mid=${id}`).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  getSelectedSupervisor(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = { data: { cid: id } };
    this.httpPost('/getSelectedSupervisior', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  discontinueSupervisor(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = { data: { cid: id } };
    this.httpGet('/V2/discontinueSupervisor', `sid=${id}`).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  saveCustomer(custObj: any, mode: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { data: custObj, mode: mode };
    console.log('b', bodyData);
    this.httpPost('/saveCustomer', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  getCustomerByNo(num: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { MobNo: num } };
    this.httpPost('/getCustomerByMob', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  saveProductDetails(saveitemObj: any, saveList: any, mode: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { data: saveitemObj, datalist: saveList, mode: mode };
    this.httpPost('/saveProduct', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  getDetailByVehicleNo(num: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('mcode changed', num);
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { vno: num } };
    this.httpPost('/getDetailByVehicleNo', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
          console.log(data);
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );

    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  getDetailByEngineNo(num: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('mcode changed', num);
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { vno: num } };
    this.httpPost('/getDetailByEngineNo', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
          console.log(data);
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );

    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  // getProductfromVID(num: string) {
  //     let res = { status: "error", result: "" };
  //     let returnSubject: Subject<any> = new Subject();
  //     console.log("about to edit");
  //     // let bodyData = { mode: 'query', data: { ACID: ACID } };
  //     let bodyData = { data: { obj: num } };
  //     this.http.post( '/getProductbyVID', bodyData, this.getRequestOption())
  //         .subscribe(response => {
  //             let data = response;
  //             console.log("getProductfromVID", data)
  //             if (data.status == 'ok') {
  //                 returnSubject.next(data);
  //                 returnSubject.unsubscribe();

  //             }
  //             else {
  //                 returnSubject.next(data)
  //                 returnSubject.unsubscribe();
  //             }
  //         }, error => {
  //             res.status = 'error'; res.result = error;
  //             returnSubject.next(res);
  //             returnSubject.unsubscribe();
  //         }
  //         );
  //     return returnSubject;
  //     /* return this.http.get("/rategroups.json").toPromise()
  //          .then((res) => res);*/

  // }
  saveamc(saveitemObj: any, saveList: any, mode: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { data: saveitemObj, datalist: saveList, mode: mode };
    console.log('bodydata', bodyData);
    this.httpPost('/saveamc', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  public getVehicleInfo() {
    if (this._VehicleInfoList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._VehicleInfoList));
    } else if (this._VehicleObservable$) {
      console.log('Obser');
      return this._VehicleObservable$;
    } else {
      console.log('api');
      //this._VehicleObservable$ = null;
      this._VehicleInfoList = [];
      return this.httpGet('/getAllProductDetails')
        .pipe((res: any) => res || [])
        .pipe(
          map((data: any) => {
            this._VehicleInfoList.push(<any>data);
            return this._VehicleInfoList;
          })
        );
      // return this._VehicleObservable$;
    }
  }

  public getVehicleInfo2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/getAllProductDetails_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }
  public getQuotationParam() {
    return this.httpGet(
      `/v2/GetReportParam?Reportname=QuotationReport`
    ).subscribe((data: any) => {
      data;
    });
  }

  getVehicleInformation() {
    return this.httpGet('/getAllProductDetails').pipe(
      map((res: any) => res || [])
    );
  }

  public getQuotationLists() {
    if (this._QuotationInfoList.length > 0) {
      console.log('array');
      return new Observable((observer) =>
        observer.next(this._QuotationInfoList)
      );
    } else if (this._QuotationObservable$) {
      console.log('Obser');
      return this._QuotationObservable$;
    } else {
      console.log('api');
      //this._QuotationObservable$ = null;
      this._QuotationInfoList = [];
      return this.httpGet('/getAllQuotationList')
        .pipe((res: any) => res || [])
        .pipe(
          map((data: any) => {
            this._QuotationInfoList.push(<any>data);
            return this._QuotationInfoList;
          })
        );
      //return this._QuotationObservable$;
    }
  }

  public getEngineNo() {
    if (this._EngineInfoList.length > 0) {
      return new Observable((observer) => observer.next(this._EngineInfoList));
    } else if (this._EngineObservable$) {
      return this._EngineObservable$;
    } else {
      //this._EngineObservable$ = null;
      this._EngineInfoList = [];
      return this.httpGet('/getAllEngineNo')
        .pipe((res: any) => res || [])
        .pipe(
          map((data: any) => {
            this._EngineInfoList.push(<any>data);
            return this._EngineInfoList;
            console.log('engineeee', data);
          })
        );
    }
  }

  public OpenFlag() {
    if (this._OpenFlagList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._OpenFlagList));
    } else if (this._OpenflagObservable$) {
      console.log('Obser');
      return this._OpenflagObservable$;
    } else {
      console.log('api');
      //this._OpenflagObservable$ = null;
      this._OpenFlagList = [];
      return this.httpGet('/GetOpenFlagVehicleOnly').pipe(
        map((data: any) => {
          this._OpenFlagList.push(<any>data);
          return this._OpenFlagList;
        })
      );
      //return this._OpenflagObservable$;
    }
  }

  public getJobDescription() {
    if (this._VehicleJobInfoList.length > 0) {
      console.log('array');
      return new Observable((observer) =>
        observer.next(this._VehicleJobInfoList)
      );
    } else if (this._VehicleJobObservable$) {
      console.log('Obser');
      return this._VehicleJobObservable$;
    } else {
      console.log('api');
      //this._VehicleJobObservable$ = null;
      this._VehicleJobInfoList = [];
      return this.httpGet('/getAllJobDescription').pipe(
        map((data: any) => {
          this._VehicleJobInfoList.push(<any>data);
          return this._VehicleJobInfoList;
        })
      );
      //return this._VehicleJobObservable$;
    }
  }

  public getallcustomer() {
    if (this._CustomerInfoList.length > 0) {
      console.log('array');
      return new Observable((observer) =>
        observer.next(this._CustomerInfoList)
      );
    } else if (this._CustomerObservable$) {
      console.log('Obser');
      return this._CustomerObservable$;
    } else {
      console.log('api');
      //this._CustomerObservable$ = null;
      this._CustomerInfoList = [];
      return this.httpGet('/getallcustomer').pipe(
        map((data: any) => {
          this._CustomerInfoList.push(<any>data);
          return this._CustomerInfoList;
        })
      );
      //return this._CustomerObservable$;
    }
  }

  public getallcustomer2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/getallcustomer_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  public OpenFlagVehicle() {
    return this.httpGet('/GetOpenFlagVehicleOnly').pipe(
      map((response: any) => response || [])
    );
  }

  public getQuotationproductList() {
    // return this.http.get( '/getQuotationproductList',this.getRequestOption())
    // .flatMap(res => res || []);

    if (this._productList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._productList));
    } else if (this._productObservable$) {
      console.log('Obser');
      return this._productObservable$;
    } else {
      console.log('api');
      //this._productObservable$ = null;
      this._productList = [];
      return this.httpGet('/getQuotationproductList').pipe(
        map((data: any) => {
          this._productList.push(<any>data);
          return this._productList;
        })
      );
      //return this._productObservable$;
    }
  }

  async BrandList_New(type: string) {
    let res = { status: 'error', result: '' };

    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { Type: type } };
    var response = await this.httpPost(
      '/GetAllBrand',
      bodyData
    ).toPromise<any>();
    var brandList: any[] = response.result;
    return brandList;
    /* return this.http.get("/rategroups.json").toPromise()
                 .then((res) => res);*/
  }

  BrandList(type: string) {
    {
      let res = { status: 'error', result: '' };
      let returnSubject: Subject<any> = new Subject();

      // let bodyData = { mode: 'query', data: { ACID: ACID } };
      let bodyData = { data: { Type: type } };
      //console.log('about to edit');
      this.httpPost('/GetAllBrand', bodyData).subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
      return returnSubject;
      /* return this.http.get("/rategroups.json").toPromise()
                 .then((res) => res);*/
    }
  }

  public getMaxJCID() {
    let returnSubject: Subject<any> = new Subject();
    this.httpGet('/getMaxJCNO').subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        returnSubject.next({ status: 'error', result: error });
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  getDetailsFromMcode(desca: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { desca: desca } };
    this.httpPost('/getDetailsFromMcode', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  getInvMainFromJobID(jobno: string) {
    {
      let res = { status: 'error', result: '' };
      let returnSubject: Subject<any> = new Subject();
      console.log('about to edit', jobno);
      // let bodyData = { mode: 'query', data: { ACID: ACID } };
      let bodyData = { data: { JNO: jobno } };
      this.httpPost('/getInvMainFromJobID', bodyData).subscribe(
        (response: any) => {
          let data = response;
          console.log('checking', response);
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
      return returnSubject;
      /* return this.http.get("/rategroups.json").toPromise()
                 .then((res) => res);*/
    }
  }
  getSyncFromJobno(jobno: string) {
    {
      let res = { status: 'error', result: '' };
      let returnSubject: Subject<any> = new Subject();
      console.log('about to edit', jobno);
      // let bodyData = { mode: 'query', data: { ACID: ACID } };
      let bodyData = { data: { JNO: jobno } };
      this.httpPost('/getSyncFromJobno', bodyData).subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
      return returnSubject;
      /* return this.http.get("/rategroups.json").toPromise()
                 .then((res) => res);*/
    }
  }

  public getAllDispatchIn() {
    if (this._DispatchInList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._DispatchInList));
    } else if (this._DispatchInObservable$) {
      console.log('Obser');
      return this._DispatchInObservable$;
    } else {
      console.log('api');
      //this._DispatchInObservable$ = null;
      this._DispatchInList = [];
      return this.httpGet('/getAllDispatchInList').pipe(
        map((data: any) => {
          this._DispatchInList.push(<any>data);
          return this._DispatchInList;
        })
      );
      //return this._DispatchInObservable$;
    }
  }

  public getAllDispatchIn2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/getAllDispatchInList_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  getJobCardFromID(jobno: string) {
    {
      let res = { status: 'error', result: '' };
      let returnSubject: Subject<any> = new Subject();
      // let bodyData = { mode: 'query', data: { ACID: ACID } };

      let bodyData = { data: { JNO: jobno } };
      this.httpPost('/getValueFromJobCardID', bodyData).subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
      return returnSubject;
      /* return this.http.get("/rategroups.json").toPromise()
                 .then((res) => res);*/
    }
  }

  async getProductFromCode(menucode: string) {
    let funcres: FunctionResponse = {
      status: 'error',
      result: '',
      result2: '',
      message: '',
      totalCount: 0,
      RefNo: '',
    };
    console.log({ menucode: menucode });
    var retData = await this.httpGetGeneric<FunctionResponse>(
      '/V2/getProductFromCode',
      `menucode=${menucode}`
    ).toPromise();
    console.log({ retData: retData });
    if (retData.status == 'ok') {
      return retData;
    }
    return funcres;
  }

  getServiceParameterFromBrand(Brand: string) {
    {
      let res = { status: 'error', result: '' };
      let returnSubject: Subject<any> = new Subject();
      // let bodyData = { mode: 'query', data: { ACID: ACID } };
      let bodyData = { data: { Brand: Brand } };
      this.httpPost(
        '/getBrandServiceParameter',
        bodyData
        // this.getRequestOption()
      ).subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
      return returnSubject;
      /* return this.http.get("/rategroups.json").toPromise()
                 .then((res) => res);*/
    }
  }

  saveJobDescription(itemname: any, mode: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { data: itemname, mode: mode };
    console.log('b', bodyData);
    this.httpPost('/saveJobDescription', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  public getAllJobDescription() {
    if (this._jobList.length > 0) {
      //   console.log({ getproductItemList: 'from Array', items: this._itemList })
      //return this._itemList;
      return new Observable((observer) => observer.next(this._jobList));
    } else if (this._JobitemListObservable$) {
      // console.log({ itemlistObservable: this._itemListObservable$ });
      return this._JobitemListObservable$;
    } else {
      //this._JobitemListObservable$ = null;
      console.log({ productItemlistReqOptions: this.getRequestOption });
      return this.http
        .post('/getAllJobs', {
          EDATE: this._lastProductChangeDateLocal,
        })
        .pipe(
          map((data: any) => {
            this._jobList.push(<Item>data);
            return this._jobList;
          })
        );
      //return this._JobitemListObservable$;
    }
  }

  public getAllJobDescription2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/getAllJobs_paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  public getDispatchOut() {
    if (this._DispatchOutList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._DispatchOutList));
    } else if (this._DispatchOutObservable$) {
      console.log('Obser');
      return this._DispatchOutObservable$;
    } else {
      console.log('api');
      //this._DispatchOutObservable$ = null;
      this._DispatchOutList = [];
      return this.httpGet('/getAllDispatchOutList').pipe(
        map((data: any) => {
          this._DispatchOutList.push(<any>data);
          return this._DispatchOutList;
        })
      );
      //return this._DispatchOutObservable$;
    }
  }

  public getDispatchOut2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/getAllDispatchOutList_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  //customer
  getSelectedCusomter(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { cid: id } };
    this.httpPost('/getSelectedCustomer', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  getSelectedMobileCustomer(mob: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    const MobileNumber = mob;
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    // let bodyData = { data: { cid: id } };
    this.httpGet('/getCustomerProducts?mobileno=' + MobileNumber).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  //JobDescription

  getSelectedJobDescription(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { id: id } };
    this.httpPost('/getSelectedJobDescription', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  //VehicleDescription and A-M-C are same datacollection

  getSelectedVehicleDescription(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { id: id } };
    console.log('about to edit', bodyData);
    this.httpPost('/getSelectedProductDetails', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  //JobcardEntry & JobCardClosed Same
  getSelectedJobCard(model: string, brand: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    // let bodyData = { data: { brand,model } };
    this.httpGet(
      `/V2/getVehicleSetting?brand=${brand}&&model=${model}`
    ).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  getSelectedModel(model: string, brand: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    // let bodyData = { data: { brand,model } };
    this.httpGet(
      `/V2/getVehicleSetting?brand=${brand}&&model=${model}`
    ).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  // SelectedTransaction

  getSelectedTransaction(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { cid: id } };
    this.httpPost('/getSelectedTransaction', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  //DeliveryIn

  getSelectedDeliveryIn(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { cid: id } };
    this.httpPost('/getSelectedDeliveryIn', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  checkDuplicateJobStart(num: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('mcode changed', num);
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { vno: num } };
    this.httpPost('/CheckDuplicateJobStart', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  checkIfDeliveryOut(num: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('mcode changed', num);
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { jno: num } };
    this.httpPost('/checkIfDeliveryOut', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  checkDuplicateAMC(num: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('mcode changed', num);
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { vno: num } };
    this.httpPost('/CheckDuplicateAMC', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  getCategoryFromBrand(Brand: string) {
    {
      let res = { status: 'error', result: '' };
      let returnSubject: Subject<any> = new Subject();
      // let bodyData = { mode: 'query', data: { ACID: ACID } };
      let bodyData = { data: { Brand: Brand } };
      this.httpPost('/getCategoryFromBrand', bodyData).subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
      return returnSubject;
      /* return this.http.get("/rategroups.json").toPromise()
                 .then((res) => res);*/
    }
  }

  getBrandFromVehicle(VehicleNo: string) {
    {
      let res = { status: 'error', result: '' };
      let returnSubject: Subject<any> = new Subject();
      // let bodyData = { mode: 'query', data: { ACID: ACID } };
      let bodyData = { data: { VNO: VehicleNo } };
      // alert("reached");
      this.httpPost('/getBrandFromVehicle', bodyData).subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
      return returnSubject;
      /* return this.http.get("/rategroups.json").toPromise()
                 .then((res) => res);*/
    }
  }

  getMAXJCID(div: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { division: div } };
    this.httpPost('/getMAXJCID', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  public getMaxServiceScheduleId(div: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = { data: { division: div } };
    this.httpPost('/getMaxServiceScheduleID', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  public getMaxAMCServiceScheduleId(div: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = { data: { division: div } };
    this.httpPost('/getMaxAMCServiceScheduleID', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  public getMaxFreeServiceId(div: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = { data: { division: div } };
    this.httpPost('/getMaxFreeServiceID', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  saveServiceSchedule(obj: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = obj;
    this.httpPost('/saveServiceSchedule', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  getAMCDateServiceSchedule(
    leadDays: any,
    soldDate: any,
    month: any,
    service: any
  ) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };

    this.httpGet(
      '/getAMCDateServiceSchedule?leaddays=' +
        leadDays +
        '&solddate=' +
        soldDate +
        '&month=' +
        month +
        '&interval=' +
        service
    ).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  getAllProductDetailfromenginekey(eno: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    const enginekey = eno;
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };

    this.httpGet(
      '/getAllProductDetailfromenginekey?eno=' + enginekey
    ).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  getAllProductDetailfromvehiclekey(eno: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    const vehiclekey = eno;
    // let bodyData = { mode: 'query', data: { ACID: ACID } };

    this.httpGet(
      '/getAllProductDetailfromvehiclekey?vno=' + vehiclekey
    ).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  saveAMCServiceSchedule(obj: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = obj;
    this.httpPost('/saveAMCServiceSchedule', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  saveFreeServiceSchedule(obj: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let bodyData = obj;
    this.httpPost('/saveFreeServiceSchedule', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  getDateServiceSchedule(model: any, date: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };

    this.httpGet(
      '/getDateServiceSchedule?modelname=' + model + '&startdate=' + date
    ).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  getScheduleDetailByModel(model: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };

    this.httpGet('/getScheduleDetailByModel?modelname=' + model).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  getMAXJobClosedID(div: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { division: div } };
    this.httpPost('/getMaxJobColsedNo', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  get_DeliveryOutCode(div: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { division: div } };
    this.httpPost('/getDeliveryOutCode', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  get_DeliveryInCode(div: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit Delivery');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { division: div } };
    this.httpPost('/getDeliveryInCode', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  getInvForJobClose(jobno: string) {
    {
      let res = { status: 'error', result: '' };
      let returnSubject: Subject<any> = new Subject();
      console.log('about to edit', jobno);
      // let bodyData = { mode: 'query', data: { ACID: ACID } };
      let bodyData = { data: { JNO: jobno } };
      this.httpPost('/getInvForJobClosed', bodyData).subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
      return returnSubject;
      /* return this.http.get("/rategroups.json").toPromise()
                 .then((res) => res);*/
    }
  }

  deleteJobcard(num: string, DelRemarks: String) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('mcode changed', num);
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { jno: num, delRemarks: DelRemarks };
    this.httpPost('/DeleteJobCard', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  //mechanic
  saveMechanic(itemname: any, mode: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { data: itemname, mode: mode };
    console.log('b', bodyData);
    this.httpPost('/saveMechanic', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  public getAllMechanic() {
    if (this._mechanicList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._mechanicList));
    } else if (this._mechanicListObservable$) {
      console.log('Obser');
      return this._mechanicListObservable$;
    } else {
      console.log('api');
      //this._mechanicListObservable$ = null;
      this._mechanicList = [];
      return this.httpGet('/getAllMechanic').pipe(
        map((data: any) => {
          this._mechanicList.push(<any>data);
          return this._mechanicList;
        })
      );
      //return this._mechanicListObservable$;
    }
  }

  public getAllMechanic2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/getAllMechanic_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  public getAllSupervisor() {
    if (this._supervisorList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._supervisorList));
    } else if (this._supervisorObservable$) {
      console.log('Obser');
      return this._supervisorObservable$;
    } else {
      console.log('api');
      //this._supervisorObservable$ = null;
      this._supervisorList = [];
      return this.httpGet('/getAllSupervisor').pipe(
        map((data: any) => {
          this._supervisorList.push(<any>data);
          return this._supervisorList;
        })
      );
      //return this._supervisorObservable$;
    }
  }

  public getAllSupervisor2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/getAllSupervisor_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }
  // public getQuotationList() {
  //     return this.http.get( '/getAllQuotationList', this.getRequestOption())
  //         .map(res => res || [])

  // }

  saveSupervisor(itemname: any, mode: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // let op: RequestOptions = new RequestOptions();
    let bodyData = { data: itemname, mode: mode };
    console.log('b', bodyData);
    this.httpPost('/saveSupervisor', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  getSelectedDeliveryOut(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { cid: id } };
    this.httpPost('/getSelectedDeliveryOut', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  // Vehicle Setting
  // saveVehicleSetting(
  //   vecObj: any,
  //   ModelList: any,
  //   CategoryList: any,
  //   Servicelist: any,
  //   TorqueList: any,
  //   mode: any
  // ) {
  //   let res = { status: 'error', result: '' };
  //   let returnSubject: Subject<any> = new Subject();
  //   // let opt = this.getRequestOption();
  //   let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
  //   // let op: RequestOptions = new RequestOptions();
  //   let bodyData = {
  //     vecObj: vecObj,
  //     modelList: ModelList,
  //     categoryList: CategoryList,
  //     servicelist: Servicelist,
  //     torqueList: TorqueList,
  //     mode: mode,
  //   };
  //   this.httpPost('/saveVehicleSetting', bodyData).subscribe(
  //     (data: any) => {
  //       let retData = data;
  //       if (retData.status == 'ok') {
  //         res.status = 'ok';
  //         res.result = retData.result;
  //         returnSubject.next(res);
  //         returnSubject.unsubscribe();
  //       } else {
  //         res.status = 'error1';
  //         res.result = retData.result;
  //         console.log(res);
  //         returnSubject.next(res);
  //         returnSubject.unsubscribe();
  //       }
  //     },
  //     (error: any) => {
  //       (res.status = 'error2'), (res.result = error);
  //       console.log(res);
  //       returnSubject.next(res);
  //       returnSubject.unsubscribe();
  //     }
  //   );
  //   return returnSubject;
  // }
  saveVehicleSetting(data: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // const options = {header:this.getRequestOption(), method:"post"}
    this.httpPost('/V2/saveVehicleSetting', data).subscribe(
      (data: any) => {
        if (data.status == 'ok') {
          returnSubject.next(data);

          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  public getAllVehicleServices() {
    if (this._SERVICESList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._SERVICESList));
    } else if (this._SERVICESListObservable$) {
      console.log('Obser');
      return this._SERVICESListObservable$;
    } else {
      console.log('api');
      //this._SERVICESListObservable$ = null;
      this._SERVICESList = [];
      return this.httpGet('/getAllServices').pipe(
        map((data: any) => {
          this._SERVICESList.push(<any>data);
          return this._SERVICESList;
        })
      );
      //return this._SERVICESListObservable$;
    }
  }

  getJobsFromServiceSelected(ser: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { service: ser } };
    this.httpPost('/getJobsFromService', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  // Vehicle setting End
  checkDuplicateVehicleNo(num: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('mcode changed', num);
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { vno: num } };
    this.httpPost('/CheckDuplicateVehicleno', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  checkDuplicatePhoneNo(num: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('mcode changed', num);
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { pno: num } };
    this.httpPost('/CheckDuplicatePhoneNo', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  public getallVehicleSetting() {
    if (this._vehicleSettingList.length > 0) {
      console.log('array');
      return new Observable((observer) =>
        observer.next(this._vehicleSettingList)
      );
    } else if (this._vehicleSettingObservable$) {
      console.log('Obser');
      return this._vehicleSettingObservable$;
    } else {
      console.log('api');
      //this._vehicleSettingObservable$ = null;
      this._vehicleSettingList = [];
      return this.httpGet('/GetAllVehicleSetting').pipe(
        map((data: any) => {
          this._vehicleSettingList.push(<any>data);
          return this._vehicleSettingList;
        })
      );
      return this._vehicleSettingObservable$;
    }
  }

  public getallVehicleSetting2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/GetAllVehicleSetting_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe((data: any) => data);
  }

  //VechileOwnerChange
  saveVehicleChangeOwner(saveitemObj: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    // ?let opt = this.getRequestOption();
    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    // l?et op: RequestOptions = new RequestOptions();
    let bodyData = { data: saveitemObj };
    // console.log("b", bodyData)
    this.httpPost('/saveChangeOwner', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }
  public getAllvehicleNo() {
    //  console.log("reacjek")
    return this.httpGet('/getAllVehicleNo').pipe(
      (response: any) => response || []
    );
  }

  getCustomerBrandwise(brand: any) {
    return this.httpGet('/getCustomerBrandwise?brandname=' + brand);
    //  .flatMap(res => res || []);
  }

  // getSelectedServiceSchedule(id)
  // {
  //     return this.http.post( '/getSelectedServiceSchedule' + id, this.getRequestOption())
  // }

  // getBrandList()
  // {
  //     return this.http.get( '/getBrandList',this.getRequestOption())
  //     .flatMap(res => res || []);
  // }

  //Quotation
  getMaxQuotationNo(div: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { division: div } };
    this.httpPost('/getMaxQuotationNo', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }
  //quotation
  savequotation(prodlist: any, saveObj: any, mode: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();

    let hd: Headers = new Headers({ 'Content-Type': 'application/json' });

    let bodyData = { trnProdList: prodlist, SaveObj: saveObj, mode: mode };
    // console.log("b", bodyData)
    this.httpPost('/saveQuotation', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);

        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  public getallquotation() {
    if (this._quotationList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._quotationList));
    } else if (this._quotationdObservable$) {
      console.log('Obser');
      return this._quotationdObservable$;
    } else {
      console.log('api');
      //this._quotationdObservable$ = null;
      this._quotationList = [];
      return this.httpGet('/V2/GetAllQuotation').pipe(
        map((data: any) => {
          this._quotationList.push(<any>data);
          return this._quotationList;
        })
      );
      return this._quotationdObservable$;
    }
  }

  public getallquotation2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/GetAllQuotation_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  public getAllModelMapping() {
    if (this._modelMappingList.length > 0) {
      console.log('array');
      return new Observable((observer) =>
        observer.next(this._modelMappingList)
      );
    } else if (this._modelMappingObservable$) {
      console.log('Obser');
      return this._modelMappingObservable$;
    } else {
      console.log('api');
      //this._modelMappingObservable$ = null;
      this._modelMappingList = [];
      return this.httpGet('/getAllServiceSchedule').pipe(
        map((data: any) => {
          this._modelMappingList.push(<any>data);
          return this._modelMappingList;
        })
      );
      return this._modelMappingObservable$;
    }
  }

  public getAllModelMapping2(currentPage: number, maxResultCount: number) {
    return this.httpGet(
      `/V2/getAllServiceSchedule_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  public getAllAMCServiceSchedule() {
    if (this._AMCList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._AMCList));
    } else if (this._AMCObservable$) {
      console.log('Obser');
      return this._AMCObservable$;
    } else {
      console.log('api');
      //this._AMCObservable$ = null;
      this._AMCList = [];
      return this.httpGet('/getAllAMCServiceSchedule').pipe(
        map((data: any) => {
          this._AMCList.push(<any>data);
          return this._AMCList;
        })
      );
      //return this._AMCObservable$;
    }
  }

  public getAllAMCServiceSchedule2(
    currentPage: number,
    maxResultCount: number
  ) {
    return this.httpGet(
      `/V2/getAllAMCServiceSchedule_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    ).pipe(map((data: any) => data));
  }

  public getAllFreeServiceSchedule() {
    if (this._freeServiceList.length > 0) {
      console.log('array');
      return new Observable((observer) => observer.next(this._freeServiceList));
    } else if (this._freeServiceObservable$) {
      console.log('Obser');
      return this._freeServiceObservable$;
    } else {
      console.log('api');
      // this._freeServiceObservable$ = null;
      this._freeServiceList = [];
      return (
        this.httpGet('/getAllFreeServiceSchedule')
          //.flatMap((res: any) => res || [])
          .pipe(
            map((data: any) => {
              this._freeServiceList.push(<any>data);
              return this._freeServiceList;
            })
          )
      );
      //return this._freeServiceObservable$;
    }
  }

  public getAllFreeServiceSchedule2(
    currentPage: number,
    maxResultCount: number
  ) {
    return this.httpGet(
      `/V2/getAllFreeServiceSchedule_Paged?pageNumber=${currentPage}&maxResultCount=${maxResultCount}`
    );
  }

  getSelectedQuotationID(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    // alert(Itemcode)
    // let bodyData = { mode: 'query', data: { ACID: ACID } };
    let bodyData = { data: { id: id } };
    this.httpPost('/getSelectedQuotation', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
    /* return this.http.get("/rategroups.json").toPromise()
             .then((res) => res);*/
  }

  getSelectedFreeServiceSchedule(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    let bodyData = { data: { id: id } };
    this.httpPost('/getSelectedFreeServiceSchedule', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  getSelectedServiceSchedule(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    let bodyData = { data: { id: id } };
    this.httpPost('/getSelectedServiceSchedule', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  getSelectedAMCServiceSchedule(id: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    console.log('about to edit');
    let bodyData = { data: { id: id } };
    this.httpPost('/getSelectedAMCServiceSchedule', bodyData).subscribe(
      (response: any) => {
        let data = response;
        if (data.status == 'ok') {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        } else {
          returnSubject.next(data);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        res.status = 'error';
        res.result = error;
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  public getVATfromGlobalclass() {
    return this.httpGet('/GetOpenFlagVehicleOnly').pipe(
      map((response: any) => response || [])
    );
  }
  getDeliverySum(jobno: string) {
    {
      let res = { status: 'error', result: '' };
      let returnSubject: Subject<any> = new Subject();
      console.log('about to edit', jobno);
      // let bodyData = { mode: 'query', data: { ACID: ACID } };
      let bodyData = { JNO: jobno };
      this.httpPost('/SumOfDelivery', bodyData).subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
      return returnSubject;
      /* return this.http.get("/rategroups.json").toPromise()
                 .then((res) => res);*/
    }
  }

  public getTotalJobClosed() {
    return this.httpGet('/getTotalJobClosed').pipe(
      map((response: any) => <any>response || [])
    );
  }

  savePassword(password: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    //let opt = this.getRequestOption();
    //let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    //let op: RequestOptions = new RequestOptions();
    let bodyData = { data: password };
    // console.log("b", bodyData)
    this.httpPost('/savepassword', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  saveforgetPassword(password: any) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    //let opt = this.getRequestOption();
    //let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
    //let op: RequestOptions = new RequestOptions();
    let bodyData = { data: password };
    // console.log("b", bodyData)
    this.httpPost('/saveforgetpassword', bodyData).subscribe(
      (data: any) => {
        let retData = data;
        if (retData.status == 'ok') {
          res.status = 'ok';
          res.result = retData.result;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        } else {
          res.status = 'error1';
          res.result = retData.result;
          console.log(res);
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      },
      (error: any) => {
        (res.status = 'error2'), (res.result = error);
        console.log(res);
        returnSubject.next(res);
        returnSubject.unsubscribe();
      }
    );
    return returnSubject;
  }

  // saveforgetPassword(password: any) {
  //   let res = { status: 'error', result: '' };
  //   let returnSubject: Subject<any> = new Subject();
  //   let opt = this.getRequestOption();
  //   let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
  //   let op: RequestOptions = new RequestOptions();
  //   let bodyData = { data: password };
  //   // console.log("b", bodyData)
  //   this.http
  //     .post(
  //        '/saveforgetpassword',
  //       bodyData,
  //       this.getRequestOption()
  //     )
  //     .subscribe(
  //       (data: any) => {
  //         let retData = data;
  //         if (retData.status == 'ok') {
  //           res.status = 'ok';
  //           res.result = retData.result;
  //           returnSubject.next(res);
  //           returnSubject.unsubscribe();
  //         } else {
  //           res.status = 'error1';
  //           res.result = retData.result;
  //           console.log(res);
  //           returnSubject.next(res);
  //           returnSubject.unsubscribe();
  //         }
  //       },
  //       (error: any) => {
  //         (res.status = 'error2'), (res.result = error);
  //         console.log(res);
  //         returnSubject.next(res);
  //         returnSubject.unsubscribe();
  //       }
  //     );
  //   return returnSubject;
  // }
  httpGet(
    urlPath: string,
    params: string = '',
    contentType: string = 'application/json'
  ) {
    var parameter: string = '';
    if (params != '') parameter = `?${params}`;
    return this.http.get(
      `${this.apiUrl}${urlPath}${parameter}`,
      this.getRequestOption(contentType)
    );
  }

  httpGetGeneric<T>(
    urlPath: string,
    params: string = '',
    contentType: string = 'application/json'
  ) {
    var parameter: string = '';
    if (params != '') parameter = `?${params}`;
    console.log({
      productFromCodeUrl: `${this.apiUrl}${urlPath}${parameter}`,
    });
    return this.http.get<T>(
      `${this.apiUrl}${urlPath}${parameter}`,
      this.getRequestOption(contentType)
    );
  }

  httpPost(
    urlPath: string,
    postParams: any,
    contentType: string = 'application/json'
  ) {
    return this.http.post(
      `${this.apiUrl}${urlPath}`,
      postParams,
      this.getRequestOption(contentType)
    );
  }
}
